export default "__VITE_ASSET__BXRW2AFx__"